import React, { Component } from "react";
import { Form, Button, Col, Container, Row } from "react-bootstrap";
import { endPoints } from "../../constant/Environment";
import { useNavigate } from "react-router-dom";
import {
  addData,
  deleteData,
  getAllData,
  getAllFilterData,
} from "../../Utility/API";
class UserSmartSearch extends Component {
  constructor(props) {
    super(props);
    // console.log(props);
    this.state = {
      stateList: [],
      kycList:[],
      playerList:[],
      accountList:[],
      rgLimitList:[],
      customerId: "",
      name: "",
      userName: "",
      email: "",
      state: "",
      acc_status: "",
      kyc_status: "",
      rg_limit: "",
      player_type: "",
    };
  }

  componentDidMount() {
    this.getStates();
    this.getPlayerTypes();
    this.getKycTypes();
    this.getAccountTypes();
    this.geRgLimitTypes();

  }
  getPlayerTypes = () => {
    let url = `${endPoints.api.playertypes}`;
    getAllData(url)
      .then((response) => {
        const { status, data, message } = response;
        
        if (status === "success") {
          this.setState({
            playerList: data,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  getKycTypes = () => {
    let url = `${endPoints.api.kycstatus}`;
    getAllData(url)
      .then((response) => {
        const { status, data, message } = response;
        
        if (status === "success") {
          this.setState({
            kycList: data,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  getAccountTypes = () => {
    let url = `${endPoints.api.accountstatus}`;
    getAllData(url)
      .then((response) => {
        const { status, data, message } = response;
        
        if (status === "success") {
          this.setState({
            accountList: data,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  geRgLimitTypes = () => {
    let url = `${endPoints.api.rgTypes}`;
    getAllData(url)
      .then((response) => {
        const { status, data, message } = response;
        
        if (status === "success") {
          this.setState({
            rgLimitList: data,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getStates = () => {
    let url = `${endPoints.api.STATES}`;

    getAllData(url)
      .then((response) => {
        const { status, data, message } = response;

        if (status === "success") {
          let statesKey = [];
          data.map((ele) => {
            ele.label = ele.state_name;
            ele.value = ele.state_id;

            statesKey.push(ele);
          });
          this.setState({
            stateList: statesKey,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  addNew = () => {
    this.props.addNew();
  };
  searchList = () => {
    let data ={
      customerId: this.state.customerId,
      name: this.state.name,
      userName: this.state.userName,
      email: this.state.email,
      state: this.state.state,
      acc_status: this.state.acc_status,
      kyc_status: this.state.kyc_status,
      rg_limit: this.state.rg_limit,
      player_type: this.state.player_type,
    }
    this.props.searchList(data);
  };

  exportCsv = (e) => {
    e.preventDefault();
    var body = {
      name: this.state.name,
      platform: this.state.platform,
      status: true,
      regdate: this.state.regdate,
      state: this.state.state,
      city: this.state.city,
      accounNumber: this.state.accounNumber,
    };

    fetch(`${endPoints.apiBaseUrl + endPoints.api.USERS_REPORT + "/csv"}`, {
      method: "POST",
      body: JSON.stringify(body),
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(function (response) {
      response.blob().then((blob) => {
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        console.log(url);
        link.href = url;
        link.download = "UsersReport.csv";
        link.click();
      });
    });
  };
  exportPdf = (e) => {
    e.preventDefault();
    var body = {
      name: this.state.name,
      platform: this.state.platform,
      status: true,
      regdate: this.state.regdate,
      state: this.state.state,
      city: this.state.city,
      accounNumber: this.state.accounNumber,
    };
    fetch(`${endPoints.apiBaseUrl + endPoints.api.USERS_REPORT + "/pdf"}`, {
      method: "POST",
      body: JSON.stringify(body),
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(function (response) {
      response.blob().then((blob) => {
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        console.log(url);
        link.href = url;
        link.download = "UsersReport.pdf";
        link.click();
      });
    });
  };

  handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      this.searchList();
    }
  };
  render() {
    return (
      <Container fluid>
        <Form>
          <Row>
            <Col>
              <Form.Group as={Col} controlId="formName">
                <Form.Label className="label">Customer ID</Form.Label>
                <Form.Control
                  type="text"
                  value={this.state.customerId}
                  onChange={(e) =>
                    this.setState({ customerId: e.target.value })
                  }
                  name="name"
                  onKeyDown={this.handleKeyDown}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formName">
                <Form.Label className="label">Name</Form.Label>
                <Form.Control
                  type="text"
                  value={this.state.name}
                  onChange={(e) => this.setState({ name: e.target.value })}
                  name="name"
                  onKeyDown={this.handleKeyDown}
                />
              </Form.Group>
            </Col>

            <Col>
              <Form.Group as={Col} controlId="formName">
                <Form.Label className="label">Username</Form.Label>
                <Form.Control
                  type="text"
                  value={this.state.userName}
                  onChange={(e) => this.setState({ userName: e.target.value })}
                  name="name"
                  onKeyDown={this.handleKeyDown}
                />
              </Form.Group>
            </Col>

            <Col>
              <Form.Group as={Col} controlId="formName">
                <Form.Label className="label">Email</Form.Label>
                <Form.Control
                  type="text"
                  value={this.state.email}
                  onChange={(e) => this.setState({ email: e.target.value })}
                  name="name"
                  onKeyDown={this.handleKeyDown}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formState">
                <Form.Label className="label">Operating State</Form.Label>
                <Form.Select
                  name="platform"
                  value={this.state.state}
                  onChange={(e) => this.setState({ state: e.target.value })}
                >
                  <option value="">Select State</option>
                  {this.state.stateList.map((item) => {
                    return (
                      <option
                        value={item.value}
                      >{`${item.state_name}(${item.state_code})`}</option>
                    );
                  })}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <Form.Group as={Col} controlId="formAccount">
                <Form.Label className="label">Account Status</Form.Label>
                <Form.Select
                  name="platform"
                  value={this.state.acc_status}
                  onChange={(e) =>
                    this.setState({ acc_status: e.target.value })
                  }
                >
                  <option value="">Select Account Status</option>
                  {this.state.accountList.map((item) => {
                    return <option value={item.id}>{item.account_status}</option>;
                  })}
                </Form.Select>
         
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formAccount">
                <Form.Label className="label">KYC Status</Form.Label>
                <Form.Select
                  name="platform"
                  value={this.state.kyc_status}
                  onChange={(e) =>
                    this.setState({ kyc_status: e.target.value })
                  }
                >
                  <option value="">Select KYC Status</option>
                  {this.state.kycList.map((item) => {
                    return <option value={item.id}>{item.kyc_status}</option>;
                  })}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formAccount">
                <Form.Label className="label">RG Limits</Form.Label>
                <Form.Select
                  name="platform"
                  value={this.state.rg_limit}
                  onChange={(e) => this.setState({ rg_limit: e.target.value })}
                >
                  <option value="">Select Rg Limit Type </option>
                  {this.state.rgLimitList.map((item) => {
                  return <option value={item.id}>{item.name}</option>;
                })}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formAccount">
                <Form.Label className="label">Player Type</Form.Label>
                <Form.Select
                  name="platform"
                  value={this.state.player_type}
                  onChange={(e) =>
                    this.setState({ player_type: e.target.value })
                  }
                >  
                 <option value="">Select Player Type </option>
                  {this.state.playerList.map((item) => {
                  return <option value={item.id}>{item.player_type}</option>;
                })}
                </Form.Select>
              </Form.Group>
            </Col>
            {/* <Col>
              <Button className="exportbtn" onClick={this.exportPdf}>
                <img src="/images/icons/pdf.png" />
              </Button>

              <Button className="exportbtn" onClick={this.exportCsv}>
                <img src="/images/icons/csv.png" />
              </Button>
            </Col>{" "} */}
            <Col>
              <Button variant="primary" onClick={this.searchList}>
                Search
              </Button>

              {/* <Button
                variant="primary"
                className="mrglft10"
                onClick={this.addNew}
              >
                Add
              </Button> */}
            </Col>
          </Row>
        </Form>
      </Container>
    );
  }
}

export default UserSmartSearch;
